<template>
  <div class="page-container">
    <div class="main-content">
      <div class="page-inner-box learn-header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
          <el-breadcrumb-item to="/study?tab=试卷">试卷列表</el-breadcrumb-item>
          <el-breadcrumb-item>试卷购买</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="page-inner-box learn-content">
        <div class="product-intro">
          <div class="preview-wrap">
            <div class="main-img">
              <img :src="currentImage" alt="Paper Image">
            </div>
          </div>
          
          <div class="item-info">
            <h1 class="item-title">{{ paper.title }}</h1>
            
            <div class="paper-meta">
              <div class="meta-item" v-if="paper.duration">
                <span class="meta-label">考试时长：</span>
                <span class="meta-value">{{ paper.duration }}分钟</span>
              </div>
              <div class="meta-item" v-if="paper.totalScore">
                <span class="meta-label">试卷总分：</span>
                <span class="meta-value">{{ paper.totalScore }}分</span>
              </div>
              <div class="meta-item" v-if="paper.questionCount">
                <span class="meta-label">题目数量：</span>
                <span class="meta-value">{{ paper.questionCount }}题</span>
              </div>
              <div class="meta-item" v-if="paper.paperType">
                <span class="meta-label">试卷类型：</span>
                <span class="meta-value">{{ paperTypeText }}</span>
              </div>
            </div>
            
            <div class="price-panel">
              <div class="price-main">
                <span class="symbol">¥</span>
                <span class="amount">{{ paper.price.toFixed(2) }}</span>
              </div>
              <div class="sales-info">
                <div class="label">试卷价格</div>
              </div>
            </div>
            
            <div class="sku-area">
              <div class="sku-row">
                <div class="sku-label">数量</div>
                <div class="sku-options">
                  <el-input-number v-model="quantity" :min="1" :max="10" size="small"></el-input-number>
                  <span class="stock-text">每人限购10份</span>
                </div>
              </div>
            </div>
            
            <div class="action-btns">
              <el-button class="btn-buy" type="primary" @click="buyNow">立即购买</el-button>
            </div>
          </div>
        </div>
        
        <div class="product-detail">
          <div class="detail-header">
            <div class="tab-title">试卷说明</div>
          </div>
          <div class="detail-content">
            <div v-if="paper.introductionHtml" class="detail-rich" v-html="paper.introductionHtml"></div>
            <div v-else class="detail-empty">暂无试卷说明</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPaperDetail } from '@/api/examApi'
import { mapGetters } from 'vuex'

const defaultPaperImage = require('@/assets/image/study_placeholder.png')

export default {
  name: 'PaperPurchase',
  data() {
    return {
      paper: {
        title: '',
        price: 0,
        duration: 0,
        totalScore: 0,
        questionCount: 0,
        paperType: undefined,
        introductionHtml: '',
        isPurchased: false
      },
      currentImage: defaultPaperImage,
      quantity: 1,
      paperId: null,
      detailLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    paperTypeText() {
      const type = this.paper && this.paper.paperType
      if (type === 2) return '模拟试卷'
      if (type === 3) return '练习试卷'
      return '试卷'
    }
  },
  created() {
    this.init()
  },
  watch: {
    '$route.params.id': 'init'
  },
  methods: {
    init() {
      const id = this.$route && this.$route.params ? this.$route.params.id : null
      this.paperId = id
      this.applyDataFromRoute()
    },
    applyDataFromRoute() {
      const query = this.$route && this.$route.query ? this.$route.query : {}
      const hasQueryData = query && (query.title || query.price || query.image)
      
      if (hasQueryData) {
        const title = query.title ? String(query.title) : ''
        const image = query.image ? String(query.image) : ''
        const price = query.price != null ? Number(query.price) : 0
        const paperType = query.paperType != null ? Number(query.paperType) : undefined
        const duration = query.duration != null ? Number(query.duration) : 0
        const totalScore = query.totalScore != null ? Number(query.totalScore) : 0
        const questionCount = query.questionCount != null ? Number(query.questionCount) : 0
        
        this.paper = {
          title,
          price,
          duration,
          totalScore,
          questionCount,
          paperType,
          introductionHtml: '',
          isPurchased: false
        }
        this.currentImage = image || defaultPaperImage
        this.quantity = 1
      }
      // 始终从API获取最新的购买状态
      this.fetchPaperDetail()
    },
    sanitizeUrl(val) {
      const s = String(val || '').trim()
      if (!s) return ''
      return s.replace(/\\`/g, '').replace(/`/g, '').trim()
    },
    sanitizeRichText(html) {
      const raw = String(html || '')
      if (!raw.trim()) return ''
      const cleaned = raw.replace(/\\`/g, '').replace(/`/g, '')
      try {
        const parser = new DOMParser()
        const doc = parser.parseFromString(cleaned, 'text/html')
        doc.querySelectorAll('script').forEach(node => node.remove())
        doc.querySelectorAll('*').forEach(el => {
          Array.from(el.attributes || []).forEach(attr => {
            const name = String(attr.name || '').toLowerCase()
            if (name.startsWith('on')) el.removeAttribute(attr.name)
          })
          if (el.hasAttribute('href')) {
            const href = this.sanitizeUrl(el.getAttribute('href'))
            if (/^javascript:/i.test(href)) el.removeAttribute('href')
            else el.setAttribute('href', href)
          }
          if (el.hasAttribute('src')) {
            const src = this.sanitizeUrl(el.getAttribute('src'))
            if (/^javascript:/i.test(src)) el.removeAttribute('src')
            else el.setAttribute('src', src)
          }
        })
        return doc.body.innerHTML || ''
      } catch (e) {
        return cleaned
      }
    },
    async fetchPaperDetail() {
      if (!this.paperId || this.detailLoading) return
      this.detailLoading = true
      try {
        const res = await getPaperDetail(this.paperId)
        const data = res && res.data ? res.data : null
        if (!data) return

        const coverImage = this.sanitizeUrl(data.coverImage)
        const introductionHtml = this.sanitizeRichText(data.introduction || data.description)
        const isPurchased = Boolean(data.isPurchased)

        this.paper = {
          title: String(data.paperName || ''),
          price: Number(data.price || 0),
          duration: Number(data.duration || 0),
          totalScore: Number(data.totalScore || 0),
          questionCount: Number(data.questionCount || 0),
          paperType: data.paperType != null ? Number(data.paperType) : undefined,
          introductionHtml,
          isPurchased
        }

        this.currentImage = coverImage || defaultPaperImage
        this.quantity = 1
      } catch (err) {
        this.$message.error((err && err.message) || '获取试卷详情失败')
      } finally {
        this.detailLoading = false
      }
    },
    buyNow() {
      if (!this.isLoggedIn) {
        window.dispatchEvent(new CustomEvent('auth:login-required', { detail: { redirect: this.$route.fullPath } }))
        return
      }
      if (this.paper && this.paper.isPurchased) {
        const isPracticePaper = Number(this.paper.paperType) === 3
        this.$router.push({
          path: isPracticePaper ? `/practice-detail/${this.paperId}` : `/exam-detail/${this.paperId}`
        })
        return
      }
      
      const paperId = this.paperId || (this.$route && this.$route.params && this.$route.params.id)
      
      this.$router.push({
        name: 'purchaseConfirm',
        params: { type: 'paper', id: paperId }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding-top: 0;
}

.main-content {
  flex: 1;
  padding-top: 20px;
}

.page-inner-box {
  max-width: 1200px;
  margin: 0 auto;
}

.learn-header {
  padding: 12px 0;
}

.learn-content {
  margin-top: 12px;
}

.product-intro {
  background: #fff;
  padding: 20px;
  display: flex;
  gap: 30px;
  border-radius: 4px;
}

.preview-wrap {
  width: 400px;
  
  .main-img {
    width: 400px;
    height: 300px;
    border: 1px solid #eee;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.item-info {
  flex: 1;
  
  .item-title {
    font-size: 20px;
    color: #333;
    margin-bottom: 15px;
    font-weight: bold;
  }
  
  .paper-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 20px;
    background: #f7f7fa;
    padding: 15px;
    border-radius: 4px;
    
    .meta-item {
      display: flex;
      align-items: center;
      gap: 8px;
      
      .meta-label {
        color: #666;
        font-size: 14px;
      }
      
      .meta-value {
        color: #3E2CCD;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
  
  .price-panel {
    background: linear-gradient(90deg, #4034eb 0%, #7c3aed 100%);
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 100px;
      height: 100px;
      background: rgba(255,255,255,0.1);
      border-radius: 50%;
      transform: translate(30%, -30%);
    }
    
    .price-main {
      display: flex;
      align-items: baseline;
      
      .symbol {
        font-size: 16px;
      }
      
      .amount {
        font-size: 32px;
        font-weight: bold;
        margin-right: 10px;
      }
    }
    
    .sales-info {
      text-align: right;
      padding-left: 20px;
      border-left: 1px solid rgba(255,255,255,0.2);
      
      .label {
        font-size: 12px;
        opacity: 0.8;
      }
    }
  }
  
  .sku-area {
    margin-bottom: 30px;
    
    .sku-row {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      
      .sku-label {
        width: 60px;
        color: #999;
        font-size: 14px;
      }
      
      .sku-options {
        display: flex;
        gap: 10px;
        align-items: center;
        
        .stock-text {
          color: #999;
          font-size: 12px;
          margin-left: 10px;
        }
      }
    }
  }
  
  .action-btns {
    display: flex;
    gap: 20px;
    margin-left: 60px;
    
    .btn-buy {
      background-color: #4034eb;
      border-color: #4034eb;
      width: 160px;
      height: 44px;
      font-size: 16px;
      
      &:hover {
        background-color: #3329c7;
        border-color: #3329c7;
      }
    }
  }
}

.product-detail {
  margin-top: 20px;
  background: #fff;
  border-radius: 4px;
  
  .detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    
    .tab-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      border-left: 4px solid #333;
      padding-left: 10px;
    }
  }
  
  .detail-content {
    padding: 20px;

    .detail-empty {
      color: #999;
      font-size: 14px;
      text-align: center;
      padding: 30px 0;
    }

    .detail-rich {
      ::v-deep img {
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>